var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white shadow rounded-full py-2 px-4 flex items-center"},[_c('b-icon',{staticClass:"mr-2",attrs:{"name":"lock"}}),_vm._v(" "+_vm._s(_vm.$t("pro_feature_badge.pro_feature"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }